export default "__VITE_ASSET__DuUjo6yH__"